import { create } from 'zustand';

interface PlanLimitModalConfig {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
}

interface PlanLimitModalStore {
  open: boolean;
  config: PlanLimitModalConfig | null;
  showPlanLimitModal: (config: PlanLimitModalConfig) => void;
  hidePlanLimitModal: () => void;
  reset: () => void;
}

export const usePlanLimitModalStore = create<PlanLimitModalStore>((set) => ({
  open: false,
  config: null,

  showPlanLimitModal: (config) => set({ open: true, config }),
  // Only flip `open` - keep the last config in state so a re-open before the
  // Radix close-transition finishes doesn't flash blank content.
  hidePlanLimitModal: () => set({ open: false }),
  reset: () => set({ open: false, config: null }),
}));
